import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { SlidersComponent } from '../sliders/sliders.component';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  constructor(public dialog:MatDialog) { }

  ProjectList=[
    {
      cardTitle:"AfricanLiveRadio",
      cardDescription:"Radio Website Comes with an algerian,marocain and tunisien channels including 2 songs.",
      cardThumb:"../../assets/Radio.png",
      demoLink:"https://radiofm-2684a.web.app"
    },
    {
    cardTitle:"MeditationTimer",
    cardDescription:"Meditation website with different timers options including couple of moods for your spirtual care.",
    cardThumb:"../../assets/Meditation.png",
    demoLink:"https://meditateweb.web.app"
  },
    {
    cardTitle:"EminFlex",
    cardDescription:"Landing page clone of netflix that shows new look of the popular movies platform.",
    cardThumb:"../../assets/Flex.png",
    demoLink:"https://eminflex-demo.onrender.com"
  },
    {
    cardTitle:"hoskiMedia",
    cardDescription:"A company Home page provide Marketing and video editing services design.",
    cardThumb:"../../assets/Hoski.png",
    demoLink:"https://www.youtube.com/embed/eqBrzH5Luj4?si=SoAixnN_eo0Pp8Jw"
  },
  ]

  
  DesignList=[
    {
    cardTitle:"Landing Page(Adobe XD)",
    cardDescription:"E-mailing Home page MOCKUP ",
    cardThumb:"../../assets/Off.png",
    demoLink:"https://www.behance.net/gallery/130862687/Home-Page/modules/741226923"
  },
    {
    cardTitle:" Movie Poster(Adobe PS)",
    cardDescription:"horror  movie poster",
    cardThumb:"../../assets/poster.png",
    demoLink:"https://www.behance.net/gallery/130854533/Witch-Movie/modules/741182907"
  },
    {
    cardTitle:"Donuet(Blender3d)",
    cardDescription:"Sculpting Donuet",
    cardThumb:"../../assets/donut.png",
    demoLink:"https://www.behance.net/gallery/130861213/Cup-of-coffee-and-Donuet"
  },
    {
    cardTitle:"Login Page(Adobe XD)",
    cardDescription:" E-mailing LOGIN MOCKUP",
    cardThumb:"../../assets/login.png",
    demoLink:"https://www.behance.net/gallery/130862963/LoginPage/modules/741228141"
  },
  ]

  openLoginForm(){
    this.dialog.open(SlidersComponent,{width:'900px',height:'650px',})
      }


  ngOnInit(): void {
  }

}
